import { SVGProps, Ref, forwardRef } from 'react';

export const LockClosedFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 6c-1.573 0-2.877.045-3.956.18.18-.956.46-1.806.842-2.493C9.555 2.483 10.498 1.8 12 1.8s2.445.683 3.114 1.887c.382.687.662 1.537.842 2.492C14.876 6.045 13.573 6 12 6m-9 9c0-5.243.499-7.494 3.156-8.413C6.64 3.021 8.313 0 12 0s5.36 3.02 5.844 6.587C20.501 7.507 21 9.757 21 15c0 7.875-1.125 9-9 9s-9-1.125-9-9m8.1 2.5h1.8v-5h-1.8z"
            fill="currentColor"
        />
    </svg>
));
LockClosedFilledSize24Glyph.displayName = 'LockClosedFilledSize24Glyph';
